// ============================================================
// THE DISPLAY'S RANDOMNESS - seeded, never Math.random.
//
// A strike's plane, a drifting head, a spark: the display wants variety,
// but E2E stubs Math.random with a seeded dice sequence, so one stray call
// would shift every later roll (gotcha 5). Every random thing the display
// draws is seeded by what it decorates (a beat's id, a figure's id, a salt),
// which also makes every screen at the table draw the same strike.
//
// Pure. Zero React dependency.
// ============================================================
import { mulberry32 } from '../mulberry32';
import { fnv1aHex } from '../../utils/fnv1a';

/**
 * A generator in [0, 1) for these keys: the same keys give the same
 * sequence on every screen. The seed is the keys' FNV-1a hash (utils/fnv1a),
 * the generator the engine's one mulberry32.
 */
export function rngFor(...keys: (string | number)[]): () => number {
  return mulberry32(parseInt(fnv1aHex(keys.join('\u241f')), 16));
}

/** A number in [lo, hi). */
export function between(rng: () => number, lo: number, hi: number): number {
  return lo + (hi - lo) * rng();
}
